common_ui = require('./modules/common_ui.js');
var nav = require('./modules/nav.js');
var form = require('./modules/form.js');
var insertBgImage = require('./modules/insert_bgimage.js');
var modal = require('./modules/modal.js');

$(function() {
	common_ui.init();
	nav.init();
	form.init();
	insertBgImage();
	modal();

	$('#kv_particlesMod')[0]
	? particlesJS.load('kv_particlesMod', '/resources/json/particles.json')
	: false;

	window.addEventListener('resize', function(e) {
		common_ui.mediaSwitchImg();
	});
});


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/script.js
// module id = 1
// module chunks = 0